import React from "react";
import Bundles from "src/pages/watcher/Bundles";
import ShowBundle from "src/pages/watcher/Bundles/Show";

const watcherRoutes = [
  { path: '/bundles', element: <Bundles /> },
  { path: '/bundles/:id',   element: <ShowBundle /> },
]

export default watcherRoutes;
